import { default_user } from '../services';
import { User } from '../types';

export default class UserState {
  me: User.Profile = default_user();
  editable_me: User.Profile = default_user();

  /**
   * TODO Для ограниченного доступа к задачам
   * для открытия необходимо добавить в массив код партнера которому будет доступна задача
   * а в компоненте добавить проверку на сравнение кода партнера с кодом из массива
   * 366457, наш код партнера для теста на stage
   */
  partner_component_access = {
    // пример массива доступных партнеров
    // CONFIRM_SHIPMENT_PRODUCTS: [
    //   '366457',
    // ],
  };

  main_menu: User.MainMenuItem[] = [];

  favorites_menu: User.MainMenuItem = {
    id: 0,
    title: '',
    slug: '',
    icon: null,
    frontend_link: null,
    is_favorite: false,
    parent: null,
    sub_menu: [],
    tag: null,
  };

  help_menu: User.MainMenuItem = {
    id: 0,
    title: '',
    slug: '',
    icon: null,
    frontend_link: null,
    is_favorite: false,
    parent: null,
    sub_menu: [],
    tag: null,
  };

  news_dialog_modal = false;
}
